module.exports = __webpack_public_path__ + "media/assets/images/blog/nosco_logo-small-e6fd89412f6ae615927702b20ba925f0.png";